import { api, apiClient } from '../client';
import type { LoginRequest, LoginResponse, MeResponse } from '@/types/api';

export interface SignupRequest {
  username: string;
  email: string;
  password: string;
}

/**
 * Authentication API endpoints
 */
export const authAPI = {
  /**
   * Login user
   */
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    // Note: The backend expects form data, but axios will handle JSON
    return apiClient.post<LoginResponse>('/login', data).then((res) => res.data);
  },

  /**
   * Self-serve signup (username + email + password). Returns the same shape as
   * login so the caller can reuse the post-login flow.
   */
  signup: async (data: SignupRequest): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>('/signup', data).then((res) => res.data);
  },

  /**
   * Get current user profile
   */
  me: async (): Promise<MeResponse> => {
    return api.get<MeResponse>('/api/me');
  },
};
